export enum TimesheetSyncStatusEnum {
  NotSent = 1,
  SentToExteralSystem = 2,
  ProcessedByExteralSystem = 3
}
